export default {
    title: "Ověření adresy",
    header: "@:views.address.verified.title",
    message: "Děkujeme za ověření vaší adresy. Tuto adresu si nyní můžete zvolit jako dodací adresu při zadávání objednávky.",
}